import PropTypes from 'prop-types';

import { STATUSES } from 'config/payment_intent';
import { paymentIntentShape } from 'helpers/shared_types';
import { formatDatetime } from 'helpers/timezone';

const PaymentIntentsCard = ({ data }) => {
  if (data.length === 0) return null;

  return (
    <div className="w-100 flex flex-column items-start justify-between">
      <div className="w-100">
        <section className="apps-grid-container th-active-users">
          <span className="apps-grid-title">Payment Intents</span>
          <div className="apps-grid">
            {data.map((a) => (
              <div key={a.id} className="apps-grid-cell mw-100vw-m">
                <article className="apps-card-app">
                  <div className="apps-card-left flex-auto">
                    <div className="apps-card-meta flex-auto">
                      <h5 className="h5 mb1-ns">€{a.amount}</h5>
                      <p className="f-supersmall midgrey ma0 word-wrap">
                        Created at: {formatDatetime(a.createdAt)}
                      </p>
                      {a.stripeId && (
                        <p className="f-supersmall midgrey ma0 word-wrap">
                          ID: {a.stripeId}
                        </p>
                      )}
                      {a.lastPaymentError && (
                        <p
                          title={a.lastPaymentError.message}
                          className="f-supersmall midgrey ws-normal ma0 mh13 two-line-text"
                        >
                          Error: {a.lastPaymentError.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="apps-card-right miw16">
                    <div className="apps-configured">
                      {a.status && (
                        <span className="th-badge">
                          <p className="ws-normal ma0">
                            {STATUSES.find((s) => s.id === a.status).label}
                          </p>
                        </span>
                      )}
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

PaymentIntentsCard.propTypes = {
  data: PropTypes.arrayOf(paymentIntentShape),
};

export default PaymentIntentsCard;
